import { API } from "./axiosInstance"

/**
 * Gets all the members from usermanagement-service
 * @returns the members
 */
export const getReceiverCodes = async () => {
  const receiverCodes = await API.get(`/receiverCodes`);
  return receiverCodes.data;
}
